/*
home2025
@update: 2025/10/11
*/

var page_ready = false;
// ページ読み込み完了後
window.addEventListener('load', ()=>{
    page_ready = true;
});

// slickスライダー
const SLIDER_SELECTOR = '.ec-slickContainer';
const initPromises = [];

// GSAP ScrollTrigger
gsap.registerPlugin(ScrollTrigger);

// スクロール途中位置でブラウザリロードされるとGSAP ScrollTriggerアニメーションが崩れるのでスクロールの自動復元を無効にしておきます。
// 「ScrollTrigger.refresh();」で効果がある場合はそちらが望ましいですが念のため自動復元無効を使います。
if (history.scrollRestoration) {
    //history.scrollRestoration = 'manual';
}

// ブラウザのリサイズ時はGSAPアニメーションを適用か否かの判別も必要なので単純にリロードさせます
$(window).on('jeia_resize', function(){
    window.location.reload();
});



$(function(){

    // slickスライダー生成と初期化完了監視モニタ
    function initializeSlickAndMonitor(sliderElement, slickOptions = {}) {
        return new Promise(resolve => {
            // 'init' イベントリスナーを設定
            $(sliderElement).on('init', function(event, slick) {
                //console.log('Slick初期化完了', sliderElement);
                resolve(); // 初期化完了時にPromiseを解決
            });

            // slickスライダー生成
            $(sliderElement).find(SLIDER_SELECTOR).slick(slickOptions);
        });
    }

    // テキストを1文字ごとspanでくくる
    function splitTextIntoChars(selector, wrapperTag = 'span') {
        const text = selector.textContent;
        let newHTML = '';
        // テキストを1文字ずつループ処理
        for (let i = 0; i < text.length; i++) {
            const char = text[i];
            // スペースは分割の邪魔になるため、通常はそのまま残すか、改行タグで置き換える
            if (char === ' ') {
                newHTML += ' '; // スペースはそのまま残す
            } else {
                newHTML += `<${wrapperTag} class="char">${char}</${wrapperTag}>`;
            }
        }
        //
        selector.innerHTML = newHTML;
    }





    /*
    ------------------------------
    home2025 function
    */

    if ( page_ready ) {
        home2025_init();
    } else {
        window.addEventListener('load', ()=>{
            page_ready = true;
            home2025_init();
        });
    }

    /*
    // shopifyヘッダー高さ
    var layoutMainPaddingTop;

    // init
    function init() {
        // shopifyヘッダー高さを#MainContentに埋め込まれるstyle要素から取得します
        var $layoutMain = document.querySelector( '#MainContent' );
        layoutMainPaddingTop = parseInt( $layoutMain.style.paddingTop );

        if ( !layoutMainPaddingTop ) {
            // ヘッダー高さが取得できるまでタイマーで監視
            setTimeout(function(){
                layoutMainPaddingTop = parseInt($layoutMain.style.paddingTop);
            }, 300);
        } else {// ヘッダー高さが判定
            // ichitoiプロモーションページの場合
            if ( $('body').hasClass('tpl-page.ichitoi2025-top') ) {
                ichitoi_top1_init();
            }

            // ichitoiイベントページの場合
            if ( $('body').hasClass('tpl-page.ichitoi2025-top2') ) {
                ichitoi_top2_init();
            }
        }
    }
    */

    // home2025 init
    function home2025_init() {

        // home2025プロモーション
        var home2025Promotion =    document.querySelector( '.home2025PromotionRole' );
        var homePromotionContent = home2025Promotion.querySelector( '.mainContent' );
        var home2025Video =        home2025Promotion.querySelector( 'video' );
        var home2025Loading =      home2025Promotion.querySelector( '.loading' );

        // キャッチテキストを1文字ずつspanタグでくくります（GSAPアニメーション用）
        splitTextIntoChars( homePromotionContent.querySelector('.catch') );

        // ローディング（動画準備完了まではローディング画面を表示）
        home2025Video.addEventListener('loadeddata', function(){
            //console.log('loadeddata');
            // 1秒後にローディング画面を消して動画再生開始
            setTimeout(function(){
                home2025Loading.classList.add('is-hidden');
                home2025Video.play();
            }, 1000);
        });

        // 動画が再生されない場合の処理
        setTimeout(function(){
            //console.log(home2025Video, home2025Video.paused);
            if (home2025Video.paused) {
                console.log('動画を再ロード')
                home2025Video.load();
            }
        }, 2000);


        // ------------------------------
        // プロモーションスクロールアニメーション（キャッチテキストをアニメーション）
        // ※本来はページ内のslickスライダー初期化を待ってからGSAP初期化を行いますがトッププロモーションなのでそこを待つ必要なないと判断しこの時点で初期化しておきます。
        const mainTl = gsap.timeline({
            scrollTrigger: {
                trigger: home2025Promotion.querySelector('.home2025PromotionRole__content'),// home2025Promotion内の動画要素.bgはfixedしておきたいのでトリガーは__content側にします
                start: 'top top',
                end:   '2000px',
                pin: true,
                scrub: 1
            }
        });

        /*
        // Y軸移動フェーズ
        mainTl.to(homePromotionContent, {
            bottom: '50vh',// homePromotionContent要素がcssでbottomで位置決めしているのでbottomを操作します
            //yPercent: -50,
            filter: 'drop-shadow(0 0 15px rgba(255, 255, 255, 0.7))',
            duration: 0.5,
            ease: "none"
        }, 0);
        */

        //  文字ごとを散らすアニメーション
        var char = /[使感]/;// 強調させる文字列
        mainTl.to(
            homePromotionContent.querySelectorAll('.char'),
            {
                x: (i, target) => gsap.utils.random(-50, 50) + (100 * Math.cos(i * 0.5)) + 0,
                y: (i, target) => gsap.utils.random(-50, 50) + (100 * Math.sin(i * 0.5)) - 50,
                scale: (i, target) => {
                    /*
                    if ( char.test(target.innerText) ) {
                        return 2.5;
                    }
                    */
                    return gsap.utils.random(0.25, 0.75);
                },
                /*
                color: (i, target) => {
                    if ( char.test(target.innerText) ) {
                        return '#cc0000'
                    }
                },
                */
                opacity: 0,
                duration: 0.5,
                stagger: {
                    each: 0.1,
                    from: 'random'
                },
                ease: "power2.in"
            },
            '-=0.3'
        );

        // 実サイト側ではトップ位置からわずかにスクロールした際にY軸下方へ一瞬沈む事があったので、gsap.set()にて対策
        const isPortrait = window.matchMedia("(orientation: portrait)");
        if(isPortrait.matches){
            // 縦長時
            var initBottom = 50;
        }
        else{
            // 横長時（cssでは「bottom: 135px」で位置決めしていますがvh値に換算
            //var initBottom = 135 / window.innerHeight * 100;
            var initBottom = 50;
        }
        gsap.set(homePromotionContent, {bottom: `${initBottom}vh`});


        // ------------------------------
        // slick初期化

        // セクション: 現在開催中のイベント
        const ichitoiInSession = document.querySelector( '.ichitoiInSessionRole' );
        if (ichitoiInSession) {
            // slickオプション
            const ichitoiInSessionOptions = {
                dots: false,
                slidesToShow: 4,
                slidesToScroll: 4,
                arrows: true,
                prevArrow: '<div class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="6.91" height="10.991" viewBox="0 0 6.91 10.991"><path d="M4416.736,1263.109l-4.789,4.788,4.789,4.788" transform="translate(-4410.533 -1262.402)" fill="none" stroke-width="2"/></svg></div>',
                nextArrow: '<div class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="6.91" height="10.991" viewBox="0 0 6.91 10.991"><path d="M4411.948,1263.109l4.789,4.788-4.789,4.788" transform="translate(-4411.241 -1262.402)" fill="none" stroke-width="2"/></svg></div>',
                appendArrows:  $(ichitoiInSession).find( '.slick-appendArrows' ),
                responsive: [
                    {
                        breakpoint: 980,// 〇〇px未満
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3
                        }
                    }
                ]
            };
            // slick生成と監視モニタ
            initPromises.push(initializeSlickAndMonitor(ichitoiInSession, ichitoiInSessionOptions));
        }


        // ------------------------------
        // slickの初期化を待ってGSAPアニメーション初期化を開始
        if (initPromises.length > 0) {
            Promise.all(initPromises)
                .then(() => {
                    //console.log("✅ 全てのSlick構築が完了しました。");
                    initializeGsapAnimations();
                })
                .catch(error => {
                    console.error("Slick初期化中にエラーが発生しました:", error);
                });

        } else {
            // スライダーが存在しない場合はすぐにGSAPを初期化
            initializeGsapAnimations();
        }


        // ------------------------------
        // GSAPアニメーション初期化
        function initializeGsapAnimations() {
            //console.log('initializeGsapAnimations');

            // 現在開催中のイベント
            if (ichitoiInSession) {
                var ichitoiInSessionItems = gsap.utils.toArray( '.item', ichitoiInSession );
                gsap.set(
                    ichitoiInSessionItems,
                    {
                        opacity: 0,
                        scale: 0.8
                    }
                );
                gsap.to(
                    ichitoiInSessionItems,
                    {
                        opacity: 1,
                        scale: 1,
                        duration: 0.5,
                        stagger: {
                            each: 0.15,
                            from: 'start'
                        },
                        scrollTrigger: {
                            trigger: ichitoiInSession,
                            start: 'top 70%',
                            once: true,
                            //markers: true
                        }
                    }
                );
            }

            // フッターコンテンツBlock1
            var ichitoiBottomContentBlock1 = document.querySelector( '.ichitoiBottomContentRole__block1' );
            if (ichitoiBottomContentBlock1) {
                var ichitoiBottomContentBlock1Items = gsap.utils.toArray( '.item', ichitoiBottomContentBlock1 );
                gsap.set(
                    ichitoiBottomContentBlock1Items,
                    {
                        y: 100,
                        opacity: 0,
                        visibility: 'hidden'
                    }
                );
                gsap.to(
                    ichitoiBottomContentBlock1Items,
                    {
                        y: 0,
                        opacity: 1,
                        visibility: 'visible',
                        duration: 0.8,
                        stagger: {
                            each: 0.1,
                            from: 'random'
                        },
                        scrollTrigger: {
                            trigger: ichitoiBottomContentBlock1,
                            start: 'top 70%',
                            once: true,
                            //markers: true
                        }
                    }
                );
            }

            // レイアウト安定後の最終リフレッシュ
            ScrollTrigger.refresh();
        }
    }




    // その他のfunction


    // jeia_resize リサイズイベント
    /**
     * iOS Safariの場合、メニューバー・アドレスバーが折りたたまれる度にresizeイベントが発火してしまいます。
     * カスタムイベントとして「jeia_resize」を準備します。こちらは基本、横幅が変化した場合にのみ発火するようにしています。
     */
    // スマホでの不要なresizeイベント発火を防ぐためブラウザ幅を記憶
    var initial_window_width = window.innerWidth;
    var resize_timer = false;
    $(window).on('resize', function(){
        if ( resize_timer !== false ) {
            clearTimeout( resize_timer );
        }
        resize_timer = setTimeout(function(){

            if ( initial_window_width != window.innerWidth ) {
                // 記憶ブラウザ幅更新
                initial_window_width = window.innerWidth;
                // jeia_resizeイベントを発火
                $(window).trigger( 'jeia_resize' );
            }
        }, 100);
    });

    // スマホ・タブレット時は一応、orientationchangeイベントでjeia_resizeを発火
    $(window).on('orientationchange', function(){
        $(window).trigger( 'jeia_resize' );
    });


    // ブロックを表示領域に入ったらふわりと表示
    if ( "IntersectionObserver" in window ) {

        // Intersection obsererの作成
        let options = {
            root: null,
            // 各ターゲット要素の高さはそれぞれなので、閾値thresholdは0としておき、rootMarginで一律固定量がブラウザ表示領域に入ったらとします
            rootMargin: '-25% 0px',
            threshold: 0
        };
        let appearEffectObserver = new IntersectionObserver( appearCheck, options );

        function appearCheck( entries, observer ) {
            //console.log('appearCheck', entries, observer);
            entries.forEach(function( entry ) {
                if ( entry.isIntersecting ) {
                    let $entryTarget = $( entry.target );
                    //console.log('appearCheck - IN', $entryTarget);
                    if ( $entryTarget.hasClass('appearEffectCustom') ) {
                        $entryTarget.addClass( 'is-appearCustom' );
                    } else {
                        $entryTarget.addClass( 'is-appear' );
                    }
                    observer.unobserve( entry.target );
                }
            });
        }

        // 監視される要素ターゲット
        var targets = [].slice.call(document.querySelectorAll( '.appearEffect, .appearEffectCustom' ));
        targets.forEach(function( entryTarget ) {
            appearEffectObserver.observe( entryTarget );
        });

    } else {
        // IE11ではサポートされません
        //console.log('Intersection Observer APIがありません');
        $( '.appearEffect' ).addClass( 'is-appear' );
        $( '.appearEffectCustom' ).addClass( 'is-appearCustom' );
    }

});